import React, { useEffect, useState } from "react";
import "../App.css";

export function Pagination({ checkedDivisions, pageCount, pageNumber, onPageChange }) {
  const [active, setActive] = useState();

  useEffect(() => {
    generatePagination(pageCount)
    setActive(pageNumber);
  }, [checkedDivisions, pageCount, pageNumber]);

  let renderPagination = [];

  const generatePagination = (count) => {
    for (let i = 1; count >= i; i++) {
      if (i === active) {
        renderPagination.push(<button key={i} className="join-item btn btn-active">{i}</button>)
        continue;
      }
      renderPagination.push(<button key={i} onClick={() => {
        setActive(i);
        onPageChange(i);
      }} className="join-item btn">{i}</button>)
    }
    return renderPagination;
  }

  return (
    <div className="join">
      {generatePagination(pageCount)}
    </div>
  );
}
